var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded h-24 w-32 flex items-center justify-center"},[_c('strong',{staticClass:"text-white text-4xl font-montserrat font-bold"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }